/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type CartLayout_localItems$ref = any;
type CartLayout_portfolioItems$ref = any;
type CartLayout_viewer$ref = any;
export type CartContainer_viewer$ref = any;
export type CartContainer_viewer = {
    readonly portfolios?: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly items: {
                    readonly totalResults: number | null;
                    readonly pageInfo: {
                        readonly hasNextPage: boolean;
                        readonly endCursor: string | null;
                    };
                    readonly edges: ReadonlyArray<{
                        readonly node: {
                            readonly item: {
                                readonly serviceId: string | null;
                                readonly ecommerceTrackingParams: unknown | null;
                            } | null;
                        } | null;
                    } | null> | null;
                    readonly " $fragmentRefs": CartLayout_portfolioItems$ref;
                } | null;
            } | null;
        } | null> | null;
    } | null;
    readonly items?: {
        readonly " $fragmentRefs": CartLayout_localItems$ref;
    } | null;
    readonly " $fragmentRefs": CartLayout_viewer$ref;
    readonly " $refType": CartContainer_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartContainer_viewer",
    "type": "Viewer",
    "metadata": {
        "connection": [
            {
                "count": "count",
                "cursor": "cursor",
                "direction": "forward",
                "path": null
            }
        ]
    },
    "argumentDefinitions": [
        {
            "kind": "LocalArgument",
            "name": "count",
            "type": "Int!",
            "defaultValue": 10
        },
        {
            "kind": "LocalArgument",
            "name": "cursor",
            "type": "String",
            "defaultValue": null
        },
        {
            "kind": "RootArgument",
            "name": "userIds",
            "type": "[String]"
        },
        {
            "kind": "RootArgument",
            "name": "hasUserId",
            "type": "Boolean"
        },
        {
            "kind": "RootArgument",
            "name": "localItemIds",
            "type": "[String]"
        },
        {
            "kind": "RootArgument",
            "name": "fetchLocalItems",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "CartLayout_viewer",
            "args": null
        },
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "portfolios",
                    "storageKey": null,
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1
                        },
                        {
                            "kind": "Literal",
                            "name": "portfolioTypes",
                            "value": [
                                "CART"
                            ]
                        },
                        {
                            "kind": "Variable",
                            "name": "userIds",
                            "variableName": "userIds"
                        }
                    ],
                    "concreteType": "PortfoliosConnection",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PortfoliosEdge",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PortfolioV2",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": "items",
                                            "name": "__CartItemList_items_connection",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PortfolioItemsConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "totalResults",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "pageInfo",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "hasNextPage",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "endCursor",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PortfolioItemsEdge",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "PortfolioItemV2",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "item",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "Item",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "serviceId",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "ecommerceTrackingParams",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "__typename",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "cursor",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "CartLayout_portfolioItems",
                                                    "args": null
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchLocalItems",
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "items",
                    "storageKey": null,
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "itemIds",
                            "variableName": "localItemIds"
                        }
                    ],
                    "concreteType": "ItemsConnection",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "CartLayout_localItems",
                            "args": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = '4663a1e5187ccb79d252aa70fe81ef2e';
export default node;
